import useFetchBrandsByGenericArticles from '@/hooks/adminTecdoc/useFetchBrandsByGenericArticles'
import useSaveBrandCategory from '@/hooks/adminTecdoc/useSaveBrandCategory'
import { Button, Checkbox, Col, Input, Row, Skeleton, Spin } from 'antd'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate } from 'react-router-dom'

const DispatchBrandCategory = () => {
  const { genericArticleId } = useParams()
  const navigate = useNavigate()

  const brands = useFetchBrandsByGenericArticles(genericArticleId)
  const [searchTerm, setSearchTerm] = React.useState('')
  const saveCategory = useSaveBrandCategory()

  const {t} = useTranslation();

  const search = useMemo(() => {
    if (!brands?.brands) return []
    if (!searchTerm) return brands?.brands
    return brands?.brands?.filter((item) =>
      item?.mfrName?.toLowerCase().includes(searchTerm.toLowerCase())
    )
  }, [searchTerm, brands?.brands])

  const onChangeChecked = async (brandId, status) => {
    if (status) {
      await saveCategory.request(brandId, 'save', genericArticleId)
      brands.setCheckedBrands((prev) => [...prev, brandId])
    } else {
      await saveCategory.request(brandId, 'remove', genericArticleId)
      brands.setCheckedBrands((prev) => prev.filter((e) => e !== brandId))
    }
  }

  const handleSelectAll = async () => {
    const allSelected = search.every((item) =>
      brands?.checkedBrands?.includes(item.dataSupplierId)
    )

    if (allSelected) {
      // Hepsini bırak
      for (const item of search) {
        await saveCategory.request(item.dataSupplierId, 'remove', genericArticleId)
      }
      brands.setCheckedBrands((prev) =>
        prev.filter((id) => !search.some((item) => item.dataSupplierId === id))
      )
    } else {
      // Hepsini seç
      for (const item of search) {
        if (!brands?.checkedBrands?.includes(item.dataSupplierId)) {
          await saveCategory.request(item.dataSupplierId, 'save', genericArticleId)
        }
      }
      brands.setCheckedBrands((prev) => [
        ...new Set([...prev, ...search.map((item) => item.dataSupplierId)]),
      ])
    }
  }

  return (
    <Skeleton loading={brands.loading}>
      {/* Geri Butonu */}
      <Button onClick={() => navigate(-1)} style={{ marginBottom: 20 }}>
        ← Geri
      </Button>

      <Input
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        size="large"
        placeholder="Search"
        style={{ marginBottom: '20px' }}
      />

      {/* Hepsini Seç / Bırak Butonu */}
      <Button
        onClick={handleSelectAll}
        type="primary"
        style={{ marginBottom: 20 }}
      >
        {search.every((item) =>
          brands?.checkedBrands?.includes(item.dataSupplierId)
        )
          ? t('release-all')
          : t('select-all')}
      </Button>

      <Spin spinning={saveCategory.loading}>
        <Row gutter={[16, 16]}>
          {search.map((item, index) => (
            <Col key={index} lg={4}>
              <Checkbox
                onChange={(e) =>
                  onChangeChecked(item?.dataSupplierId, e.target.checked)
                }
                checked={brands?.checkedBrands?.includes(item?.dataSupplierId)}
                value={item?.dataSupplierId}
              >
                {item.mfrName}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Spin>
    </Skeleton>
  )
}

export default DispatchBrandCategory
